import * as React from 'react';
import { Link } from 'react-router-dom';
import { resolve } from 'inversify-react';

import { DataTableView, Column } from 'src/core/ui/data-table.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { FormatService } from 'src/core/services/format.service';

interface Props extends ComponentViewProps<DataSet<PolicySummary>> {
	onItemDoubleClicked: (item?: PolicySummary) => void;
}

export class PolicyListView extends React.Component<Props, {}> {
	@resolve
	private formatService: FormatService;

	render() {
		const { model, setBusy } = this.props;
		const columns: Column[] = [
			{
				key: 'displayName',
				title: 'Name',
				dataIndex: 'displayName',
				render: (text, record: PolicySummary) => <Link to={`/bookings/policies/${record.id}`}>{text}</Link>,
			},
			{
				key: 'commission',
				title: 'Commission',
				dataIndex: 'commission',
				render: (value) => this.formatService.toString('percent-full', value),
			},
			{
				key: 'isActive',
				title: 'Is Active',
				dataIndex: 'isActive',
				render: (text, record) => (
					<BooleanView
						label={null}
						size="small"
						mode="display"
						value={record.isActive}
					/>
				)
			}
		];

		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						model={model}
						columns={columns}
						setBusy={setBusy}
						itemDoubleClick={(item) => {
							if (this.props.onItemDoubleClicked) {
								this.props.onItemDoubleClicked(item);
							}
						}}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/policies/list/policy-list.view.tsx